/*
 * Copyright (C) 2022 Adrien Fery. All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import { graphql } from 'gatsby';
import { Link, Trans } from 'gatsby-plugin-react-i18next';
import * as React from 'react';
import Seo from '../components/seo';
import Layout from '../layouts/layout';

export default function NotFoundPage()
{
  return (
    <Layout navbarOptions={{ transparent: true }}>
      <Seo noIndex={true} />
      <div className="h-screen text-white bg-cover bg-gradient-to-r from-gray-700 to-gray-900">
        <div className='pt-48 text-center'>
          <h1 className='mb-4'><Trans>Page Not Found</Trans></h1>
          <p className='text-white'><Trans>The page you're looking for is 404 not here</Trans></p>
          <Link to="/" className='mt-8 inline-flex mx-auto px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-primary-500 hover:bg-primary-600'><Trans>Back Home</Trans></Link>
        </div>
      </div>
    </Layout>
  );
};


export const query = graphql`
  query($language: String!) {
    locales: allLocale(filter: {language: {eq: $language}}) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
